<template>
    <table class="w-full">
        <thead>
            <th class="p-2 text-left">Category</th>
            <th class="p-2 text-left">
                Avg
                <span class="hidden md:inline-block">Score (last 100 Qs)</span>
            </th>
            <th class="w-32 p-2 text-right">
                Points <span class="hidden md:inline-block">earned</span>
            </th>
            <th class="w-12 p-2 text-right"></th>
        </thead>
        <tbody>
            <template v-for="focusArea in focusAreas">
                <StudentReadinessQuizPerformanceCategoryRow
                    :focus-area="focusArea"
                />
            </template>
        </tbody>
    </table>
</template>
<script>
import StudentReadinessQuizPerformanceCategoryRow from "@/Pages/NewStudentBackend/StudentReadinessQuizPerformanceCategoryRow.vue";

export default {
    name: "StudentReadinessScoreDetailsQuizPerformance",
    components: { StudentReadinessQuizPerformanceCategoryRow },
    props: {
        focusAreas: {
            type: Object,
            default: {},
        },
    },
};
</script>
